var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-branch-container"
  }, [_vm.props.payload.content.header ? _c('div', {
    class: ['card-title-container', _vm.isPC ? 'card-title' : 'card-title-h5']
  }, [_vm._v(" " + _vm._s(_vm.props.payload.content.header) + " ")]) : _vm._e(), _vm._l(_vm.props.payload.content.items, function (item, index) {
    return _vm.props.payload.status === 0 && _vm.canSelect ? _c('div', {
      key: index,
      class: ['form-branch-item', item.content ? '' : 'warning-item'],
      on: {
        "click": function ($event) {
          return _vm.listItemClick(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.content || _vm.TUITranslateService.t('AIDesk.分支选项异常')) + " ")]) : _vm._e();
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }